import React from "react";

const Footer = () => {
  return (
    <section className="footer-section" id="contact">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 p-5 align-self-center">
            <h3 className="text-center fw-bold text-uppercase mb-4">
              Contact Us
            </h3>
            <div className="contact-area">
              <div className="contact-item">
                <p className="text-center">
                  <span className="fw-bold ">Address: </span>
                  Office No. 78, Street 90, G6-3 Islamabad
                </p>
              </div>
              <div className="contact-item">
                <p className="text-center">
                  <span className="fw-bold ">Email Address: </span>
                  <a href="mailto:info@magmusconsulting.com.pk">info@magmusconsulting.com.pk</a>
                </p>
              </div>
              <div className="contact-item">
                <p className="text-center">
                  <span className="fw-bold ">Phone Number: </span>
                  <a href="00518912473">051-8912473</a> or{" "}
                  <a href="003211501084">03211501084</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 p-0">
            <div
              className="map-container"
              data-location="73.09019347056804, 33.72388184634532"
            >
              <input
                type="hidden"
                id="hdnMapAPI"
                value="pk.eyJ1Ijoia2hhbGVkbW45NSIsImEiOiJja2R2Z2NwOHEyaTg0MnF0dmdyazlrdDY1In0.3pIEAtkbZtYPlH-G0vZKMQ"
              />
              <div id="map" className="map w-100"></div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 p-0">
            <div className="copyright-area py-3 bg-dark">
              <p className="text-center mb-0">
                2022 &#169;{" "}
                <a href="/" className="fw-bold">
                  MAGMUS
                </a>{" "}
                | Developed by{" "}
                <a
                  href="https://webspark.group/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-bold"
                >
                  webspark
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
